document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("compare-section")) {
    customElements.define(
      "compare-section",
      class CompareSection extends HTMLElement {
        constructor() {
          super();
          this.init();
        }

        init() {
          try {
            this.toggleButtons = this.querySelectorAll(
              "[data-compare-button-id]"
            );
            this.compareCards = this.querySelectorAll(
              "[data-compare-product-id]"
            );
            this.setupEventListeners();
          } catch (error) {
            console.error("Initialization error:", error);
          }
        }

        setupEventListeners() {
          this.toggleButtons.forEach((button) => {
            button.addEventListener("click", this.handleButtonClick.bind(this));
          });
        }

        handleButtonClick(event) {
          try {
            const buttonId = event.currentTarget.getAttribute(
              "data-compare-button-id"
            );
            this.toggleButtons.forEach((button) => {
              button.classList.toggle("active", button === event.currentTarget);
            });
            this.compareCards.forEach((card) => {
              card.classList.toggle(
                "active",
                card.getAttribute("data-compare-product-id") === buttonId
              );
            });
          } catch (error) {
            console.error("Button click error:", error);
          }
        }
      }
    );
  }
});
